import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('ums_roles')
export class RoleEntity {

    @PrimaryGeneratedColumn({ name: 'id' })
    id: number;

    @Column('varchar', {
        name: 'name',
        length: 100,
        unique: true
    })
    name: string;

    @Column('varchar', {
        name: 'description',
        length: 255,
        nullable: true
    })
    description: string;
}
